import { useEffect, useState } from 'react';
import { useEquipo } from '../context/EquipoContext';
import { getEquipos } from '../services/api';

const MEDALLAS = { 1: '🥇', 2: '🥈', 3: '🥉' };

const TABS = [
  { id: 'futbol', label: '⚽ Fútbol',  campo: 'elo' },
  { id: 'padel',  label: '🎾 Pádel',   campo: 'elo_padel' },
  { id: 'tenis',  label: '🎾 Tenis',   campo: 'elo_tenis' },
];

function getIniciales(nombre) {
  if (!nombre) return '??';
  return nombre.split(' ').filter(p => p.length > 0).slice(0,2).map(p => p[0].toUpperCase()).join('');
}

function getColores(id) {
  const pares = [
    ['#EF4444','#B91C1C'], ['#1A6BFF','#0F4FCC'],
    ['#16A34A','#166534'], ['#7C3AED','#5B21B6'],
    ['#FF6B1A','#CC5214'], ['#F59E0B','#D97706'],
    ['#0891B2','#0E7490'], ['#DC2626','#1D4ED8'],
  ];
  return pares[(id || 0) % pares.length];
}

export default function Ranking() {
  const { equipo, deporteActivo } = useEquipo();
  const [equipos,  setEquipos]  = useState([]);
  const [cargando, setCargando] = useState(true);
  const [tabActivo, setTabActivo] = useState(deporteActivo || 'futbol');

  useEffect(() => {
    setCargando(true);
    getEquipos()
      .then(data => { if (Array.isArray(data)) setEquipos(data); })
      .catch(() => {})
      .finally(() => setCargando(false));
  }, []);

  const tabInfo    = TABS.find(t => t.id === tabActivo);
  const campoElo   = tabInfo?.campo || 'elo';

  // Filtrar por deporte del tab y ordenar por ELO correspondiente
  const equiposFiltrados = equipos
    .filter(e => {
      if (tabActivo === 'futbol') return !e.deporte || e.deporte === 'futbol';
      return e.deporte === tabActivo;
    })
    .sort((a, b) => (b[campoElo] || 1000) - (a[campoElo] || 1000));

  const miPosicion = equiposFiltrados.findIndex(e => e.id === equipo?.id);

  return (
    <div style={styles.pagina}>

      <div style={styles.header}>
        <div style={styles.titulo}>Ranking ELO</div>
        <div style={styles.sub}>
          Equipos ordenados por ELO · {equiposFiltrados.length} registrados
        </div>
      </div>

      <div style={styles.contenido}>

        {/* Tabs deportes */}
        <div style={styles.tabs}>
          {TABS.map(t => (
            <button
              key={t.id}
              onClick={() => setTabActivo(t.id)}
              style={{
                ...styles.tab,
                background:  tabActivo === t.id ? '#FF6B1A' : 'white',
                color:       tabActivo === t.id ? 'white'   : '#6B7280',
                border:      `1.5px solid ${tabActivo === t.id ? '#FF6B1A' : '#E8ECF4'}`,
              }}
            >
              {t.label}
            </button>
          ))}
        </div>

        {/* Mi posición */}
        {equipo && miPosicion >= 0 && (
          <div style={styles.miPosicionCard}>
            <div style={styles.miPosicionLabel}>Tu posición actual</div>
            <div style={styles.miPosicionRow}>
              <div style={styles.miPosicionNum}>#{miPosicion + 1}</div>
              <div style={styles.miPosicionNombre}>{equipo.nombre}</div>
              <div style={styles.miPosicionElo}>{equipo[campoElo] || 1000} ELO</div>
            </div>
          </div>
        )}

        {cargando ? (
          <div style={styles.cargando}>Cargando ranking...</div>
        ) : equiposFiltrados.length === 0 ? (
          <div style={styles.vacio}>
            <div style={styles.vacioIcono}>🏆</div>
            <div style={styles.vacioTitulo}>Sin equipos registrados aún</div>
            <div style={styles.vacioSub}>
              El ranking aparecerá cuando haya equipos de {tabInfo?.label} registrados.
            </div>
          </div>
        ) : (
          <div style={styles.tabla}>
            <div style={styles.tablaHeader}>
              <div style={{ width: 40 }}></div>
              <div style={{ flex: 1, ...styles.th }}>Equipo</div>
              <div style={{ width: 80, ...styles.th, textAlign: 'center' }}>ELO</div>
              <div style={{ width: 80, ...styles.th, textAlign: 'center' }}>Partidos</div>
              <div style={{ width: 80, ...styles.th, textAlign: 'center' }}>Victorias</div>
              <div style={{ width: 80, ...styles.th, textAlign: 'center' }}>% Vic.</div>
            </div>

            {equiposFiltrados.map((e, i) => {
              const esYo    = e.id === equipo?.id;
              const [c1,c2] = getColores(e.id);
              const partidos  = e.partidos  || 0;
              const victorias = e.victorias || 0;
              const winRate   = partidos > 0 ? Math.round((victorias / partidos) * 100) : 0;
              const pos = i + 1;
              const eloValor = e[campoElo] || 1000;

              return (
                <div
                  key={e.id}
                  style={{
                    ...styles.fila,
                    background:  esYo ? '#EFF5FF' : 'white',
                    borderLeft:  esYo ? '3px solid #1A6BFF' : '3px solid transparent',
                  }}
                >
                  <div style={{ width: 40, textAlign: 'center' }}>
                    {MEDALLAS[pos]
                      ? <span style={styles.medalla}>{MEDALLAS[pos]}</span>
                      : <span style={styles.posNum}>{pos}</span>}
                  </div>

                  <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{
                      ...styles.crest,
                      background: `linear-gradient(135deg, ${e.color_principal || c1}, ${e.color_secundario || c2})`,
                    }}>
                      {getIniciales(e.nombre)}
                    </div>
                    <div>
                      <div style={{ ...styles.equipoNombre, color: esYo ? '#1A6BFF' : '#141922', fontWeight: esYo ? 800 : 700 }}>
                        {e.nombre}{esYo && <span style={styles.yoBadge}> Tú</span>}
                      </div>
                      <div style={styles.equipoZona}>{e.zona}</div>
                    </div>
                  </div>

                  <div style={{ width: 80, textAlign: 'center' }}>
                    <div style={styles.eloNum}>{eloValor}</div>
                  </div>
                  <div style={{ width: 80, textAlign: 'center', ...styles.celda }}>{partidos}</div>
                  <div style={{ width: 80, textAlign: 'center', ...styles.celda }}>{victorias}</div>
                  <div style={{ width: 80, textAlign: 'center' }}>
                    <div style={styles.winRate}>{winRate}%</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div style={styles.notaElo}>
          El ELO se actualiza automáticamente después de cada partido.
          Ganar contra equipos de mayor ELO da más puntos.
        </div>
      </div>
    </div>
  );
}

const styles = {
  pagina: { minHeight: '100vh', background: '#F4F6FA' },
  header: { background: '#0D1117', padding: '24px 32px', borderBottom: '1px solid rgba(255,255,255,0.06)', marginBottom: 24 },
  titulo: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 32, fontWeight: 800, color: 'white', marginBottom: 4 },
  sub: { fontSize: 13, color: 'rgba(255,255,255,0.4)', fontFamily: "'Barlow', sans-serif" },
  contenido: { padding: '0 32px 32px' },
  tabs: { display: 'flex', gap: 8, marginBottom: 20 },
  tab: { padding: '9px 18px', borderRadius: 20, cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: 14, fontWeight: 700, transition: 'all 0.12s' },
  miPosicionCard: { background: '#0D1117', borderRadius: 14, padding: '16px 20px', marginBottom: 20 },
  miPosicionLabel: { fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.3)', textTransform: 'uppercase', letterSpacing: '0.05em', fontFamily: "'Barlow', sans-serif", marginBottom: 8 },
  miPosicionRow: { display: 'flex', alignItems: 'center', gap: 16 },
  miPosicionNum: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 40, fontWeight: 800, color: '#1A6BFF', lineHeight: 1 },
  miPosicionNombre: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 22, fontWeight: 800, color: 'white', flex: 1 },
  miPosicionElo: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 20, fontWeight: 700, color: '#FF6B1A' },
  cargando: { textAlign: 'center', padding: '60px', fontSize: 13, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" },
  vacio: { textAlign: 'center', padding: '60px 20px' },
  vacioIcono: { fontSize: 48, marginBottom: 16 },
  vacioTitulo: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 24, fontWeight: 800, color: '#141922', marginBottom: 8 },
  vacioSub: { fontSize: 14, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif", maxWidth: 360, margin: '0 auto', lineHeight: 1.6 },
  tabla: { background: 'white', border: '1px solid #E8ECF4', borderRadius: 16, overflow: 'hidden', marginBottom: 16 },
  tablaHeader: { display: 'flex', alignItems: 'center', padding: '12px 20px', background: '#F4F6FA', borderBottom: '1px solid #E8ECF4' },
  th: { fontSize: 10, fontWeight: 700, color: '#9BA5B7', textTransform: 'uppercase', letterSpacing: '0.06em', fontFamily: "'Barlow', sans-serif" },
  fila: { display: 'flex', alignItems: 'center', padding: '14px 20px', borderBottom: '1px solid #F4F6FA', transition: 'background 0.12s' },
  medalla: { fontSize: 20 },
  posNum: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 16, fontWeight: 700, color: '#9BA5B7' },
  crest: { width: 36, height: 36, borderRadius: 8, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Barlow Condensed', sans-serif", fontSize: 12, fontWeight: 800, color: 'white' },
  equipoNombre: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 15, marginBottom: 1 },
  yoBadge: { background: '#1A6BFF', color: 'white', fontSize: 9, fontWeight: 700, padding: '1px 6px', borderRadius: 10, fontFamily: "'Barlow', sans-serif", marginLeft: 6 },
  equipoZona: { fontSize: 11, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" },
  eloNum: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 18, fontWeight: 800, color: '#141922' },
  celda: { fontSize: 14, fontWeight: 600, color: '#4A5568', fontFamily: "'Barlow', sans-serif" },
  winRate: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 15, fontWeight: 700, color: '#1A6BFF' },
  notaElo: { fontSize: 12, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif", textAlign: 'center', lineHeight: 1.6, fontStyle: 'italic' },
};
